import { css } from "styled-components";
import { defaultTheme } from "./theme";
import { mediaMaxWidth } from "./mediaQueriesTemplates";

export const cardHeaderStyles = css`
  display: flex;
  border-bottom: 1px solid #d8d8d8;
  color: ${defaultTheme.colors.black};
  font-weight: ${defaultTheme.fontWeight.bolder};
  font-family: ${defaultTheme.fontFamily};
  font-size: ${defaultTheme.fontSize.normal.desktop};
  padding: 5px 10px;
  margin-bottom: 10px;

  ${mediaMaxWidth.tablet} {
    font-size: ${defaultTheme.fontSize.normal.mobile};
  }
`;

export const cardContentStyles = css`
  display: flex;
  padding: 0 10px;
  line-height: ${defaultTheme.lineHeight.desktop};
  font-size: ${defaultTheme.fontSize.normal.desktop};
  font-family: ${defaultTheme.fontFamily};

  ${mediaMaxWidth.tablet} {
    line-height: ${defaultTheme.lineHeight.mobile};
    font-size: ${defaultTheme.fontSize.normal.mobile};
  }
`;
